<div class="vc-sales-list">
  <!-- Quick Stats Bar -->
  <div class="vc-sales-list__stats-bar vc-surface-panel vc-surface-panel--padded">
    <div class="vc-sales-list__stat">
      <span class="vc-sales-list__stat-value">{{ salesCount }}</span>
      <span class="vc-sales-list__stat-label">{{
        "SALES.STATS.COUNT" | translate
      }}</span>
    </div>
    <div class="vc-sales-list__stat vc-sales-list__stat--primary">
      <span class="vc-sales-list__stat-value"
        >{{ totalAmount | number: "1.2-2" }} €</span
      >
      <span class="vc-sales-list__stat-label">{{
        "SALES.STATS.TOTAL" | translate
      }}</span>
    </div>
  </div>

  <!-- Loading State -->
  <div class="vc-sales-list__loading" *ngIf="loading">
    <div class="vc-sales-list__skeleton" *ngFor="let i of [1, 2, 3, 4, 5]">
      <p-skeleton height="60px"></p-skeleton>
    </div>
  </div>

  <!-- Empty State -->
  <div
    class="vc-sales-list__empty"
    *ngIf="!loading && filteredSales.length === 0"
  >
    <i class="fas fa-receipt"></i>
    <h3>{{ "SALES.EMPTY.TITLE" | translate }}</h3>
    <p>{{ "SALES.EMPTY.DESCRIPTION" | translate }}</p>
  </div>

  <!-- Desktop Table -->
  <div
    class="vc-sales-list__table-container vc-surface-panel vc-surface-panel--table"
    *ngIf="!loading && filteredSales.length > 0 && !isMobile"
  >
    <p-table
      #salesTable
      [value]="filteredSales"
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[10, 20, 50, 100]"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'COMMON.TABLE.PAGINATION' | translate }}"
      styleClass="p-datatable-sm"
      [tableStyle]="{ 'min-width': '100%' }"
      [sortField]="'sales_date'"
      [sortOrder]="-1"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="vc-sales-list__col vc-sales-list__col--date" pSortableColumn="sales_date">
            {{ "COMMON.DATE" | translate }}
            <p-sortIcon field="sales_date"></p-sortIcon>
          </th>
          <th class="vc-sales-list__col vc-sales-list__col--image"></th>
          <th>{{ "SALES.TITLES.PRODUCT" | translate }}</th>
          <th class="vc-sales-list__col vc-sales-list__col--price" pSortableColumn="price">
            {{ "COMMON.PRICE" | translate }}
            <p-sortIcon field="price"></p-sortIcon>
          </th>
          <th>{{ "COMMON.PATIENT" | translate }}</th>
          <th class="vc-sales-list__col vc-sales-list__col--payment">{{ "SALES.PAYMENT_METHOD" | translate }}</th>
          <th class="vc-sales-list__col vc-sales-list__col--actions text-center">
            {{ "COMMON.ACTIONS" | translate }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-sale>
        <tr>
          <td>
            <span class="vc-sales-list__date">
              {{ formatDate(sale.sales_date) }}
            </span>
          </td>
          <td>
            <div class="vc-sales-list__product-photo">
              <app-product-image
                [image_url]="getProductImage(sale)"
              ></app-product-image>
            </div>
          </td>
          <td>
            <div class="vc-sales-list__product">
              <span class="vc-sales-list__product-name">
                {{ getProductOrTreatment(sale) }}
              </span>
            </div>
          </td>
          <td>
            <span class="vc-sales-list__price">
              {{ formatPrice(sale) }}
            </span>
          </td>
          <td>
            <app-patient-link
              *ngIf="sale.patient"
              [patient]="sale.patient"
            ></app-patient-link>
            <span *ngIf="!sale.patient" class="vc-sales-list__no-patient">
              Sin paciente
            </span>
          </td>
          <td>
            <p-tag
              *ngIf="sale.paymentType"
              [value]="getPaymentMethodName(sale)"
              severity="info"
            ></p-tag>
            <span *ngIf="!sale.paymentType">-</span>
          </td>
          <td class="text-center">
            <div class="vc-sales-list__actions">
              <button
                pButton
                class="p-button-text p-button-sm"
                (click)="editSale(sale)"
                *ngIf="hasPermission('SALES.UPDATE')"
                pTooltip="{{ 'COMMON.EDIT' | translate }}"
              >
                <i class="fas fa-edit"></i>
              </button>
              <app-delete-button-sale
                *ngIf="hasPermission('SALES.DELETE')"
                [payload]="sale"
                [onDelete]="onDelete"
              ></app-delete-button-sale>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Mobile Cards -->
  <div
    class="vc-sales-list__cards"
    *ngIf="!loading && filteredSales.length > 0 && isMobile"
  >
    <div class="vc-sales-list__card" *ngFor="let sale of filteredSales">
      <div class="vc-sales-list__card-header">
        <span class="vc-sales-list__card-date">
          {{ formatDate(sale.sales_date) }}
        </span>
      </div>

      <div class="vc-sales-list__card-body">
        <div class="vc-sales-list__card-product-main">
          <div class="vc-sales-list__card-product-image">
            <app-product-image
              [image_url]="getProductImage(sale)"
            ></app-product-image>
          </div>

          <div class="vc-sales-list__card-product-copy">
            <strong>{{ getProductOrTreatment(sale) }}</strong>
            <span class="vc-sales-list__card-price">
              {{ formatPrice(sale) }}
            </span>
          </div>
        </div>

        <div class="vc-sales-list__card-patient" *ngIf="sale.patient">
          <i class="fas fa-user"></i>
          <span>{{ getPatientFullName(sale.patient) }}</span>
        </div>

        <div class="vc-sales-list__card-patient" *ngIf="!sale.patient">
          <i class="fas fa-user-slash"></i>
          <span>Sin paciente</span>
        </div>

        <div class="vc-sales-list__card-payment" *ngIf="sale.paymentType">
          <i class="fas fa-credit-card"></i>
          <span>{{ getPaymentMethodName(sale) }}</span>
        </div>
      </div>

      <div class="vc-sales-list__card-actions">
        <button
          pButton
          class="p-button-text p-button-sm"
          (click)="editSale(sale)"
          *ngIf="hasPermission('SALES.UPDATE')"
        >
          <i class="fas fa-edit"></i>
          {{ "COMMON.EDIT" | translate }}
        </button>
        <app-delete-button-sale
          *ngIf="hasPermission('SALES.DELETE')"
          [payload]="sale"
          [onDelete]="onDelete"
        ></app-delete-button-sale>
      </div>
    </div>
  </div>
</div>
